
import { Component, Mixins, Prop } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component
export default class RemoteFeatureFlagsEditableItem extends Mixins(DarkThemeInfoMixin) {
    @Prop({ default: false }) isDisabled!: boolean;
    @Prop({ default: false }) valid!: boolean;
    @Prop({ default: false }) isCreator!: boolean;
    @Prop({ default: '' }) flagName!: string;
    @Prop({ default: '' }) description!: string;
    @Prop({ default: '' }) expirationDate!: string;

    get validValue() {
        return this.valid;
    }
    set validValue(value: boolean) {
        this.$emit('update:valid', value);
    }
    get flagNameValue() {
        return this.flagName;
    }
    set flagNameValue(value: string) {
        this.$emit('update:flagName', value);
    }
    get descriptionValue() {
        return this.description;
    }
    set descriptionValue(value: string) {
        this.$emit('update:description', value);
    }
    get expirationDateValue() {
        return this.expirationDate;
    }
    set expirationDateValue(value: string) {
        this.$emit('update:expirationDate', value);
    }

    menu = false;

    get expirationAlertType(): 'error' | 'warning' | null {
        if (!this.expirationDate) return null;
        const now = new Date();
        const expiration = new Date(this.expirationDate);
        if (isNaN(expiration.getTime())) return null;
        if (expiration <= now) return 'error';
        const oneMonthFromNow = new Date(now);
        oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
        const threeMonthsFromNow = new Date(now);
        threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);
        if (expiration <= oneMonthFromNow) return 'error';
        if (expiration <= threeMonthsFromNow) return 'warning';
        return null;
    }

    get expirationAlertMessage(): string {
        if (!this.expirationDate) return '';
        const expiration = new Date(this.expirationDate);
        if (expiration <= new Date()) return 'Flag expired.';
        if (this.expirationAlertType === 'error') return 'Expires in less than a month.';
        if (this.expirationAlertType === 'warning') return 'Expires in less than 3 months.';
        return '';
    }

    dateValidator(value: number) {
        if (!value) {
            return 'Expiration date is required';
        }
        if (new Date(value) < new Date()) {
            return 'Expiration date must be in the future';
        }
        return true;
    }
}
